@if (hasItems()) {
<section class="launcher-card d-flex flex-column">
  <header class="launcher-header d-flex align-items-center">
    <mat-icon class="header-icon">bolt</mat-icon>
    <h2 class="header-title">{{ 'app.home.launcher.title' | translate }}</h2>
  </header>

  <div class="launcher-grid">
    @for (item of items(); track item.key) {
    <a class="launcher-tile d-flex flex-column" [routerLink]="item.routerLink"
      [matTooltip]="item.descriptionKey | translate">
      <mat-icon class="tile-icon">{{ item.icon }}</mat-icon>
      <span class="tile-label">{{ item.labelKey | translate }}</span>
    </a>
    }
  </div>
</section>
}
